export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '7b76969', dateTime: 1764971186739 };